export default {

    namespaced: true,

    state: {
        amount: 0,
        card: null,
        payment_history: false,
        one_click_opt_in: true,
    },

    mutations: {
        setAmount(state, value) {
            state.amount = value
        },
        setCard(state, value) {
            state.card = value
        },
        setPaymentHistory(state, value) {
            state.payment_history = value
        },
        setOneClick(state, value) {
            state.one_click_opt_in = value;
        }
    },

    actions: {
        setAmount({commit}, value) {
            commit('setAmount', value)
        },
        setCard({commit}, value) {
            commit('setCard', value)
        },
        setPaymentHistory({commit}, value) {
            commit('setPaymentHistory', value)
        },
        setOneClick({commit}, value) {
            commit("setOneClick", value);
        }
    },

    getters: {}

}